import { faFileArrowDown } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Box, Tooltip } from "@mui/material"
import { translate } from "app/language/service"
import { IRootState } from "app/model"
import { getActiveAppContext } from "app/tools/common"
import { FORM_TAB_BOXES, IForm } from "form/model"
import { getForm } from "form/tools/common"
import { setCreativeFilter } from "form/tools/creative"
import { downloadRequiredCreatives } from "form/tools/creative-campaign"
import { getRequiredMediaCreativeBoxTranslation } from "form/tools/creative-forecast"
import React from "react"
import { connect } from "react-redux"
import { FlexBox } from "ui/components/FlexBox"
import { MAX_PHONE_WIDTH_IN_PX, MAX_TABLET_WIDTH_IN_PX } from "ui/model"
import { CreativeCampaignBox } from "./creative/CreativeCampaignBox"
import { CreativeDspDealBox } from "./creative/CreativeDspDealBox"
import { CreativeForecastBox } from "./creative/CreativeForecastBox"
import { SelectionFilter } from "./filter/SelectionFilter"
import { ContentBoxLayout } from "./layout/ContentBoxLayout"

interface IContentCreativesProps {
  form: IForm | null
  isDesktop: boolean
  isPhone: boolean
}

const ContentCreativesFn = React.memo(({ form, isDesktop, isPhone }: IContentCreativesProps) => {
  if (!form) {
    return null
  }
  const isForecastForm = form.context.isForecast
  const isDspDealForm = form.context.isDspDeal
  return (
    <Box
      sx={{
        "width": "100%",
        "height": "100%",
        "mt": 0,
        "gap": "1rem",
        "& > *": {
          width: "100%"
        }
      }}>
      <ContentBoxLayout
        id={
          isForecastForm
            ? FORM_TAB_BOXES.CREATIVE_FORECAST_LIST
            : isDspDealForm
              ? FORM_TAB_BOXES.CREATIVE_DSP_DEAL_LIST
              : FORM_TAB_BOXES.CREATIVE_CAMPAIGN_LIST
        }
        fullHeight
        title={translate(isDspDealForm ? "dsp-deal.format" : "campaign.creative.required.title")}
        subTitle={isForecastForm ? getRequiredMediaCreativeBoxTranslation() : undefined}
        isDesktopScreen={isDesktop}>
        <FlexBox
          gap
          fullWidth
          jc="end"
          sx={{
            "pr": "1rem",
            "mt": "-2rem",
            "& .icon": {
              color: theme => theme.palette.text.primary
            },
            "& .icon-span": {
              zIndex: 10
            },
            "& .icon-span:hover .icon": {
              color: theme => theme.palette.primary.main,
              cursor: "pointer"
            }
          }}>
          {!isDspDealForm && (
            <SelectionFilter
              id="form-creative-filter-selection"
              value={form.creatives.filter}
              selectedLabel={isForecastForm ? undefined : translate("campaign.creative.uploaded")}
              notSelectedLabel={isForecastForm ? undefined : translate("campaign.creative.not.uploaded")}
              onChange={newSelectFilter => setCreativeFilter(form.context.appContext, newSelectFilter)}
              sx={{ minWidth: isPhone ? "100%" : "14rem", maxWidth: isPhone ? "100%" : "14rem" }}
            />
          )}
          {!isForecastForm && !isDspDealForm && (
            <Tooltip title={translate("campaign.creative.export.csv")}>
              <span
                id="form-creative-download-button"
                onClick={() => downloadRequiredCreatives(form)}
                className="icon-span">
                <FontAwesomeIcon icon={faFileArrowDown} size="2x" className="icon" />
              </span>
            </Tooltip>
          )}
        </FlexBox>
        {isForecastForm ? (
          <CreativeForecastBox form={form} />
        ) : isDspDealForm ? (
          <CreativeDspDealBox form={form} />
        ) : (
          <CreativeCampaignBox form={form} />
        )}
      </ContentBoxLayout>
    </Box>
  )
})

export const ContentCreatives = connect(
  (state: IRootState): IContentCreativesProps => ({
    form: getActiveAppContext(state) ? getForm(state) : null,
    isDesktop: state.ui.container.width > MAX_TABLET_WIDTH_IN_PX,
    isPhone: state.ui.container.width <= MAX_PHONE_WIDTH_IN_PX
  })
)(ContentCreativesFn)
